import React, { useRef, useState }              from 'react';
import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import moment                                   from 'moment';
import Swal                                     from 'sweetalert2';
import { Formik }                               from 'formik';
import * as yup                                 from 'yup';

import audienceCourt                            from '../../../../data/audienceCourt';
import ButtonSpinner                            from '../../../layout/ButtonSpinner'
import clienteAxios                             from '../../../../config/axios';
import { ICON_CANCEL, ICON_CALENDAR_CHECK }     from '../../../extras/icons';
import { WaitingMessage, ErrorMessage }         from '../../../extras/toastMessages';





const AssistedForm = props => {


    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================

    // Tomo los props
    const { show, handleClose, audience, setOptions, setJudges, handleOptions, hide } = props;
    
    // Genero los ref
    const refMinimo = useRef();

    // Inicializo duración
    let initDuracion = 0;
    let initMinimo = 0;
    let initMaximo = 0;
    let initTribunal = 0;



    // ==========================================================================================
    // CARGA DE VALORES -------------------------------------------------------------------------
    // ==========================================================================================

    // Calculo la duración inicial
    audience.audienciaTipoList.map( type => {
        // Siempre tomo la mayor duración
        if(type.tiempo > parseInt(initDuracion))
        {   initDuracion = type.tiempo;
        }
        // Siempre tomo el menor mínimo
        if(type.plazoMinimo < parseInt(initMinimo))
        {   initMinimo = type.plazoMinimo;
        }
        // Siempre tomo el mayo máximo
        if(type.plazoMaximo > parseInt(initMaximo))
        {   initMaximo = type.plazoMaximo;
        }
    })

    // Inicializo datos
    const initialData = {
        duracion: initDuracion,
        maximo: initMaximo,
        minimo: initMinimo,
        tribunal: initTribunal
    }

    // Inicializo el state local
    const [loading, setLoading] = useState(false);



    // ==========================================================================================
    // FUNCIONES --------------------------------------------------------------------------------
    // ==========================================================================================

    // Manejo cuando se muestra
    const handleOnShow = e => {
        // Pongo el foco en el primer campo
        refMinimo.current.focus();
    }

    // Manejo el guardado
    const handleSave = async values => {
            try 
            {   // Muestro ventana
                WaitingMessage('Buscando disponibilidad');
                // Armo los datos
                const data = {
                    duracion: values.duracion,
                    ejecucion: false,
                    plazoMaximo: values.maximo,
                    plazoMinimo: values.minimo,
                    tribunal: values.tribunal
                }
                // Hago la consulta
                const response = await clienteAxios.post(`/buscar-disponibilidad/${audience.id}`, data);
                // Verifico la respuesta
                const res = response.data;
                // Seteo los datos
                setOptions(res.huecos);
                // Seteo los jueces
                setJudges(res.juezList);
                // Muestro las opciones
                handleOptions();
                // Oculto espera
                Swal.close();
            }
            catch(error) 
            {   const response = error.response;
                let data = {
                    data: null,
                    message: 'Error al conectarse al servidor'
                };
                // Verifico si hay error
                if(response) 
                {   data = response.data;
                }
                // Oculto la espera
                Swal.close();
                // Mensaje de error
                ErrorMessage(data.message);
            }
    }

    // Esquema de validación
    const validationSchema = yup.object({
        duracion: yup.number().integer().required(),
        maximo: yup.number().integer().required(),
        minimo: yup.number().integer().required(),
        tribunal: yup.number().integer().required()
    });



    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ==========================================================================================

    return (
        <Modal
            show = { show } 
            onHide = { handleClose } 
            onShow = { handleOnShow } 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            size = "lg"
        >
            {   hide 
                    ? 
                        <div className="custom-backdrop-modal"></div>
                    : 
                        null
            }
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Agendamiento Asistido</strong> <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...initialData }}
                onSubmit = { values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <Form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <Row>
                                <Col xs="12">
                                    <Alert variant="warning">
                                        Tipo/s de Audiencia
                                        <br/>
                                        <strong>
                                        {   audience.audienciaTipoList.map((type, index) => (
                                                <React.Fragment key={`aiat${type.id}`}>
                                                    {`${index > 0 ? ', ' : ''}${type.descripcion}`}
                                                </React.Fragment>
                                            ))
                                        }
                                        </strong>
                                    </Alert>
                                </Col>
                                <Col xs="12">
                                    <Alert variant="info">
                                        Debe indicar el <strong>PLAZO MÍNIMO y MÁXIMO (en días)</strong> para celebrar la audiencia, como así también la <strong>DURACIÓN (en minutos)</strong> de la misma.
                                        Luego presione el botón de <strong>BUSCAR</strong>
                                    </Alert>
                                </Col>
                                <Col xs="12">
                                    Fecha Solicitud: <strong>{ audience.fechaSolicitud ? moment(audience.fechaSolicitud).format('DD/MM/YYYY HH:mm') : '' }</strong>
                                    <hr/>
                                </Col>
                                <Form.Group className="col-12 col-md-4">
                                    <label htmlFor="minimo">Plazo mínimo</label>
                                    <Form.Control
                                        id = "minimo"
                                        className = "form-control" 
                                        autoFocus 
                                        name = "minimo" 
                                        type = "text" 
                                        placeholder = "Ingrese plazo"
                                        value = { values.minimo }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.minimo }
                                        disabled = { loading }
                                        ref = { refMinimo }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.minimo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-4">
                                    <label htmlFor="minimo">Plazo máximo</label>
                                    <Form.Control
                                        id = "maximo"
                                        className = "form-control" 
                                        name = "maximo" 
                                        type = "text" 
                                        placeholder = "Ingrese plazo"
                                        value = { values.maximo }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.maximo }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.maximo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-4">
                                    <label htmlFor="duracion">Duración</label>
                                    <Form.Control
                                        id = "duracion"
                                        className = "form-control" 
                                        name = "duracion" 
                                        type = "text" 
                                        placeholder = "Ingrese duración"
                                        value = { values.duracion }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.duracion }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.duracion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-4">
                                    <label htmlFor="tribunal">Tribunal?</label>
                                    <Form.Control
                                        as = "select"
                                        id = "tribunal"
                                        className = "form-control"  
                                        name = "tribunal" 
                                        value = { values.tribunal }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.tribunal }
                                        disabled = { loading }
                                    >
                                        {   audienceCourt
                                                ?
                                                    audienceCourt.map( tribunal => (
                                                        <option key={tribunal.id} value={tribunal.id}>{ tribunal.descripcion }</option>
                                                    ))
                                                :   
                                                    null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tribunal }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            {   loading 
                                    ? 
                                        <ButtonSpinner />
                                    : 
                                        <Button variant="success" type="submit" disabled={ loading }>
                                            <ICON_CALENDAR_CHECK /> <strong>BUSCAR</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default AssistedForm;
